module.exports = __webpack_public_path__ + "img/trending.a34152cf.png";